import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Util } from './libs/ruvpp-angular2-comun';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

    public static message: string;

    /**
     * 
     * @param _router
     */
    constructor(private _router: Router) { }

    ngOnInit() {
        Util.forward(this._router, 'Login');
    }

    /**
     * 
     * @param message
     */
    public static setMessage(message: string) {
        this.message = message;
    }

    public getMessage(): string {
        return AppComponent.message;
    }

}
